// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1vheP","label":"Completed_label__COVDM"};